import { ReactNode } from "react";
import { Outlet } from "react-router-dom";

export function withOutlet<P extends { children: ReactNode }>(
  Component: React.ComponentType<P>
) {
  function ComponentWithOutlet(props: Omit<P, "children">) {
    return (
      // @ts-expect-error
      <Component {...props}>
        <Outlet />
      </Component>
    );
  }
  ComponentWithOutlet.displayName = `withOutlet(${Component.displayName || Component.name})`;
  return ComponentWithOutlet;
}
